import { render, staticRenderFns } from "./ProductPricesList.vue?vue&type=template&id=620a822e"
import script from "./ProductPricesList.vue?vue&type=script&lang=js"
export * from "./ProductPricesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports